/* eslint-disable */
import axios from "axios";
import jwt_decode from "jwt-decode";
import * as XLSX from "xlsx";
import store from "../../store/index";
import VuePdfEmbed from 'vue-pdf-embed';
import customModal from "../customModal/customModal.vue";
import moment from "moment";
export default {
    name: "f4p",
    components:{
        VuePdfEmbed,
        customModal
    },
    data(){
        return{
            baseurl: process.env.VUE_APP_Service_URL,
            fileuploadurl: process.env.VUE_APP_File_upload_URL + "/document",
            n8nautomationurl: process.env.VUE_APP_N8N_ENV,
            dataToken: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJUeXBlIjoiQXBwbGljYXRpb24iLCJPcmdhbmlzYXRpb24iOiJTdHVkeUltcG9ydCIsIkFwcE5hbWUiOiJEYXRhRXh0cmF0IiwiZXhwIjo0ODg4NTU0MDk5fQ.MzdW7sv6VevOJkyRDIeziSrChlDJf3sr9WEfGRJXaFA",
            idToken:"",
            selectedFile:"",
            selectedstudy:"",
            studylist:[],
            downloadName:"",
            source:"",
            officeurl:"",
            documentRefId:"",
            documentVersion:"",
            organizationId:"",
            documentTitle:"",
            documentDescription:"",
            studyFiles: [],
            protocolDetails: {
                fileName: "",
                status: "",
                documentRefId: "",
                documentVersion: "",
                uploadResultRefId: "",
                uploadResultVersion: ""
            },
            azuredata: {
                DocumentDescription: "",
                DocumentTitle: "",
                OrganizationId: ""
            },
            soaPages:[""],
            validations:[false,false],
            showLoading:false,
            showSoaPageValidation:false,
            showValidation:false,
            showCancel:false,
            dragActive: false,
            readyToView: false,
            fileUploaded:false,
            importLoader:false,
            isLandscape: false,
            dataInput:"",
        }
    },
    mounted() {
        this.idToken = store.getters.getIdToken;
        if (this.idToken) {
            const decodedToken = jwt_decode(this.idToken);
            this.organizationId = decodedToken.organizationId;
            this.azuredata.OrganizationId = decodedToken.organizationId;
        }
    },
    methods: {
        closeAssignModal(){
            this.$emit('closemodel')
        },
    async getstudy() {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(
          `${this.baseurl}/management/study/getallstudy`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          console.log(res);
          this.studylist = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
        },
        previewFiles(event) {
            console.log("entered preview",event)
            this.fileUploaded=false
            this.showValidation = false
            this.studyFiles = Array.from(event.target.files);
            this.documentTitle = this.studyFiles?.[0]?.name?.replace(/\.pdf$/i, "") || "";
            this.azuredata.DocumentTitle = this.documentTitle;
            if(this.studyFiles && this.studyFiles.length!=0){
                this.fileUploaded=true              
            }
        },
        async protocolExport() {
            if (this.studyFiles.length == 0) {
                this.showValidation = true
                this.readyToView=false
            }
            else {
                this.showValidation = false;
                this.source = URL.createObjectURL(this.studyFiles[0]);
                this.readyToView = true;
            }
        },
        async createDocumentDMS(){
            this.showValidation = false;
            this.azuredata.DocumentTitle = this.documentTitle || this.studyFiles?.[0]?.name?.replace(/\.pdf$/i, "") || "";
            this.azuredata.DocumentDescription = "Uploaded protocol to DMS.";
            const dmsFormData = new FormData();
          
            [...this.studyFiles].forEach((file) => {
                dmsFormData.append("Document", file);
            });
  
            dmsFormData.append("DocumentTypeName", "STUDY_PROTOCOL");
            dmsFormData.append("DocumentTitle", this.azuredata.DocumentTitle);
            dmsFormData.append("DocumentDescription", this.azuredata.DocumentDescription);
            dmsFormData.append("OrganizationId", this.azuredata.OrganizationId || "");
  
           try {
            const response = await axios.post(
                `${this.baseurl}/dms/document/create`,
                dmsFormData,
                {
                headers: {
                    Authorization: "Bearer " + this.idToken,
                    "Content-Type": "multipart/form-data",
                },
                }
            );
  
            this.protocolDetails.documentRefId = response.data.data[0];
            this.protocolDetails.documentVersion = response.data.data[1];
            this.documentRefId = response.data.data[0];
            this.documentVersion = response.data.data[1];
            } catch (err) {
                console.log("error", err);
                this.protocolDetails.status = "Upload failed in DMS";
                throw err;
            }
              
        },
        async setdoc() {
                this.source = `${this.fileuploadurl}/file/${this.documentRefId}?versionid=${this.documentVersion}`;      
                this.readyToView=true      
                this.officeurl = `https://view.officeapps.live.com/op/embed.aspx?src=${this.source}`
        },
        addSoaPageField() {
            this.soaPages.push("");
            this.showSoaPageValidation = false;
        },
        handleSoaPageFocus(index) {
            if (index === 0 && this.soaPages.length === 1) {
                this.addSoaPageField();
            }
        },
        removeSoaPageField(index) {
            this.soaPages.splice(index, 1);
            if (this.soaPages.length === 0) {
                this.soaPages.push("");
            }
            this.showSoaPageValidation = false;
        },
        getSoaPagesValue() {
            return this.soaPages
                .map((page) => `${page}`.trim())
                .filter((page) => page !== "")
                .join(";");
        },
        async importSoA() {
            const soaPagesValue = this.getSoaPagesValue();

            // Validation
            if (!this.studyFiles || this.studyFiles.length === 0) {
                this.showValidation = true;
                return;
            }
            if (soaPagesValue === "") {
                this.showSoaPageValidation = true;
                return;
            }
 
            this.showSoaPageValidation = false;
            this.showValidation = false;
            this.importLoader = true;
 
            const soaFileImport = new FormData();
 
            // Append multiple files
            this.studyFiles.forEach((file) => {
                soaFileImport.append("file", file);
            });
 
            // Append inputs
            soaFileImport.append("page_numbers", soaPagesValue);
            soaFileImport.append("study", "");
            soaFileImport.append("isLandscape", this.isLandscape ? "true" : "false");
 
            let response;
            try {
                var idToken = store.getters.getIdToken
                response = await axios.post(
                    `${this.baseurl}/protocol-extraction-py/soaextraction/extract-for-ids`,
                    soaFileImport,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                            "Authorization": `Bearer ${idToken}`,
                        },
                        responseType: "blob",
                    }
                );
            } catch (err) {
                const status = err?.response?.status;
                const statusText = err?.response?.statusText;
                const message = err?.message || "Unknown error";

                console.error("SoA extraction request failed:", err);
                console.error("SoA extraction failure details:", {
                    message,
                    status,
                    statusText,
                    headers: err?.response?.headers,
                    data: err?.response?.data
                });

                if (status) {
                    alert(`SoA extraction request failed: ${status} ${statusText || ""}`.trim());
                } else {
                    alert(`SoA extraction request failed before the follow-up APIs started: ${message}`);
                }
                return;
            }

            try {
                const uploadedPdfFile = this.studyFiles?.[0] || null;
                const uploadedBaseName =
                    this.studyFiles?.[0]?.name?.replace(/\.[^.]+$/, "") ||
                    this.documentTitle ||
                    "soa_extraction";
                const extractedFileName = `${uploadedBaseName}.xlsx`;
                const extractedBlob = new Blob([response.data], {
                    type: response.headers["content-type"] || "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                });

                const extractedLink = document.createElement("a");
                extractedLink.href = URL.createObjectURL(extractedBlob);
                // extractedLink.download = extractedFileName;
                document.body.appendChild(extractedLink);
                // extractedLink.click();
                document.body.removeChild(extractedLink);
                URL.revokeObjectURL(extractedLink.href);
                await this.downloadJsonFromExcelBlob(extractedBlob, extractedFileName);

                console.log("SoA post-processing: starting createDocumentDMS");
                await this.createDocumentDMS();
                console.log("SoA post-processing: createDocumentDMS completed");

                const extractedXlid =
                    response.headers["xlid"] ||
                    response.headers["XLID"] ||
                    response.headers["XlId"] ||
                    response.headers["x-lid"] ||
                    response.request?.getResponseHeader?.("xlid") ||
                    response.request?.getResponseHeader?.("XLID") ||
                    "";

                this.dataInput = extractedXlid;
                console.log("extract-for-ids response headers:", response.headers);
                console.log("extract-for-ids xlid:", this.dataInput);

                if (!this.dataInput) {
                    throw new Error("Missing xlid header from extract-for-ids response. The backend may not be exposing this header to the browser.");
                }

                console.log("SoA post-processing: starting dataService");
                const processedExcelFile = await this.dataService();
                console.log("SoA post-processing: dataService completed");

                this.studyFiles = [];
                this.$refs.inputProtocol.value = null;
                this.soaPages = [""];
                this.selectedstudy = "";
                this.isLandscape = false;

                alert(this.$t("navigations.soa extracted successfully"));
                this.$emit("import-complete", {
                    fileName: extractedFileName,
                    pdfFile: uploadedPdfFile,
                    excelFile: processedExcelFile
                });
            } catch (err) {
                console.error("SoA extraction post-processing failed:", err);
                this.protocolDetails.status = "Upload failed in DMS";
                const status = err?.response?.status;
                const statusText = err?.response?.statusText;
                const message = err?.message || "Unknown error";
                console.log(
                    status
                        ? `SoA extraction completed, but a follow-up step failed: ${status} ${statusText || ""}`.trim()
                        : `SoA extraction completed, but a follow-up step failed: ${message}`
                );
            } finally {
                this.importLoader = false;
            }
        },
        async dataService() {
            try {
                const url = `${this.baseurl}/dataservices/centraldatahub/download/${this.dataInput}`;
                const response = await axios.get(url, {
                    headers: {
                        Authorization: `Bearer ${this.dataToken}`,
                        Accept: "*/*"
                    },
                    responseType: "blob"
                });

                const excelMime = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
                const blob = new Blob(
                    [response.data],
                    {
                        type:
                            response.headers["content-type"] === "application/octet-stream"
                                ? excelMime
                                : response.headers["content-type"]
                    }
                );

                const downloadName = this.documentTitle || this.studyFiles?.[0]?.name?.replace(/\.pdf$/, "") || "download";
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = `${downloadName}.xlsx`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                try {
                    const n8nFd = new FormData();
                    n8nFd.append("PDF", this.studyFiles[0]);
                    n8nFd.append("Excel", blob, `${downloadName}.xlsx`);

                    const n8nResp = await axios.post(`${this.n8nautomationurl}`, n8nFd, {
                        responseType: "blob",
                        timeout: 10 * 60 * 1000
                    });

                    const cd = n8nResp.headers["content-disposition"] || "";
                    const m = /filename\*=UTF-8''([^;]+)|filename="?([^"]+)"?/i.exec(cd);
                    const zipName = decodeURIComponent((m?.[1] || m?.[2] || `${downloadName}.zip`));
                    const zipBlob = n8nResp.data;
                    const zipLink = document.createElement("a");
                    zipLink.href = URL.createObjectURL(zipBlob);
                    zipLink.download = zipName;
                    document.body.appendChild(zipLink);
                    zipLink.click();
                    document.body.removeChild(zipLink);
                } catch (n8nErr) {
                    console.log("n8n call failed; continuing existing flow.", n8nErr);
                }

                const downloadedFile = new File([blob], `${downloadName}.xlsx`, { type: response.headers["content-type"] });
                await this.saveDownloadedFileToDMS(downloadedFile);
                await this.CreateProtocolDetails(downloadedFile);
                return downloadedFile;
            } catch (error) {
                console.error("Error downloading the file:", error);
                throw error;
            }
        },
        async downloadJsonFromExcelBlob(blob, fileName) {
            try {
                const arrayBuffer = await blob.arrayBuffer();
                const workbook = XLSX.read(arrayBuffer, { type: "array" });
                const jsonData = {};

                workbook.SheetNames.forEach((sheetName) => {
                    jsonData[sheetName] = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], { defval: "" });
                });

                const jsonBlob = new Blob(
                    [JSON.stringify(jsonData, null, 2)],
                    { type: "application/json" }
                );
                const jsonFileName = fileName.replace(/\.[^.]+$/, "") + ".json";
                const jsonLink = document.createElement("a");
                jsonLink.href = URL.createObjectURL(jsonBlob);
                jsonLink.download = jsonFileName;
                document.body.appendChild(jsonLink);
                jsonLink.click();
                document.body.removeChild(jsonLink);
                URL.revokeObjectURL(jsonLink.href);
            } catch (error) {
                console.error("Failed to convert extracted file to JSON:", error);
            }
        },
        async saveDownloadedFileToDMS(file) {
            const dms = new FormData();
            dms.append("Document", file);
            dms.append("DocumentTypeName", "STUDY_PROTOCOL_RESPONSE");
            dms.append("DocumentTitle", file.name||"");
            dms.append("DocumentDescription", "Processed protocol in DMS.");
            dms.append("OrganizationId", "");

            const res = await axios.post(
                `${this.baseurl}/dms/document/create`,
                dms,
                { headers: { Authorization: `Bearer ${this.idToken}`, "Content-Type": "multipart/form-data" } }
            );

            this.protocolDetails.uploadResultRefId = res.data.data[0];
            this.protocolDetails.uploadResultVersion = res.data.data[1];
            this.protocolDetails.fileName = file.name;
            this.protocolDetails.status = "Success";
        },
        async CreateProtocolDetails(downloadfile) {
            try {
                const res = await axios.post(
                    `${this.baseurl}/management/document/createstudyprotocol`,
                    this.protocolDetails,
                    { headers: { Authorization: `Bearer ${this.idToken}` } }
                );

                if (res.data) {
                    await this.CreateDataScrap(downloadfile, res.data);
                }
            } catch (err) {
                console.error(err);
                throw err;
            }
        },
        async CreateDataScrap(file,refId) {
            const fd = new FormData();
            fd.append("File", file);
            await axios.post(
                `${this.baseurl}/management/studyprotocol/importprotocol?protocolRefId=${refId}`,
                fd,
                { headers: { Authorization: `Bearer ${this.idToken}` } }
            );
        }
    }
}
